export default __webpack_public_path__ + "static/media/SalesAnalyticsDesktop.36d201b1.png";